var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyBelt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 76,
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1489 16.2389L11.5488 19.1839C11.5488 19.1839 9.78711 25.5741 14.5581 25.5741C19.3291 25.5741 17.3838 19.1839 17.3838 19.1839L19.3018 6.47298C19.3236 5.87986 19.2185 5.28887 18.9937 4.73958C18.7688 4.19029 18.4295 3.69527 17.998 3.28768C17.5666 2.88009 17.0534 2.56933 16.4922 2.37606C15.931 2.18278 15.3351 2.1116 14.7441 2.16707C10.0211 2.16707 9.81299 5.91798 9.81299 6.47298L10.0649 8.32308",
    stroke: "#818181",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.8619H42.844",
    stroke: "#ACACAD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.897 14.391L11.149 16.238",
    stroke: "#D3D4D4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2998 10.0289L10.8968 14.3909",
    stroke: "#818181",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0669 8.32312L10.2999 10.0301",
    stroke: "#D3D4D4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.56 23.2821C14.56 23.2821 7.54196 77.2 68.249 47.912",
    stroke: "#C0C1C1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8018 34.84L89.5298 38.1649L87.2212 42.4869H79.8447L82.813 36.171L87.2129 34.9969L87.8018 34.84Z",
    fill: "#805E25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.373 36.17L54.3398 42.486H46.9731L44.6729 38.1639L46.396 34.839L46.9771 34.9921L51.373 36.17Z",
    fill: "#805E25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9689 64.8781H44.6689V70.4991H46.9689V64.8781Z",
    fill: "#AB3012"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5168 64.8781H87.2168V70.4991H89.5168V64.8781Z",
    fill: "#AB3012"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2881 43.6171H63.853V47.1581H54.3447V43.6171H63.2881Z",
    fill: "#AB3012"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5938 43.6171H79.8418V47.1581H70.334V43.6171H71.5938Z",
    fill: "#AB3012"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 65.7611V70.4989H54.3408V65.765L55.0317 64.8781H79.1509L79.8408 65.7611Z",
    fill: "#AB3012"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.249 47.912L67.0947 49.392L65.9448 47.912H68.249Z",
    fill: "#303030"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0947 38.714L70.895 43.6139H63.2842L67.0947 38.714Z",
    fill: "#303030"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.334 47.1581V47.912H63.853V42.8871L63.873 42.8629H70.3149L70.335 42.8871L70.334 47.1581Z",
    fill: "#C0C1C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 63.9989V64.8781H79.1538L67.0947 49.392L68.249 47.912H70.333V47.1581H73.6499L79.8398 55.1381L79.8408 63.9989Z",
    fill: "#805E25"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9448 47.912L67.0947 49.392L55.0352 64.8781H54.3438V55.139L60.5391 47.1591H63.8521V47.913L65.9448 47.912Z",
    fill: "#805E25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 22.2899V33.026L71.5928 43.6171H70.8979L70.333 42.8871V42.8629H70.313L67.0938 38.714L79.8408 22.2899Z",
    fill: "#805E25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0947 38.714L63.8721 42.8629H63.8521V42.8871L63.2871 43.6171H62.6001L54.3438 33.0099V22.2889L67.0947 38.714Z",
    fill: "#805E25"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 33.026V22.2899L87.2168 25.3051V34.9969L82.8169 36.171L79.8491 42.4869L79.8408 33.026Z",
    fill: "#FFB237"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3447 33.0099V42.486L51.3779 36.17L46.9688 34.993V25.3051L54.3447 22.2899V33.0099Z",
    fill: "#FFB237"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2168 71.3751H79.8408V75.2971H87.2168V71.3751Z",
    fill: "#FFB237"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3447 71.3751H46.9688V75.2971H54.3447V71.3751Z",
    fill: "#FFB237"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3447 55.139V63.9989H46.9731V49.8629H54.3491L54.3447 55.139Z",
    fill: "#FFB237"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2168 49.8629V63.9989H79.8408V49.8629H87.2168Z",
    fill: "#FFB237"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3447 47.1581V49.858H46.9731V42.4821H54.3491V47.1539L54.3447 47.1581Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2168 47.1581V49.858H79.8408V42.4821H87.2168V47.1539V47.1581Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3447 71.3761H46.9731V64.0001H54.3491V71.3761H54.3447Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8408 71.3761H87.2168V64.0001H79.8408V71.3761Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.791 47.0099V49.3099H47.5229V43.0421H53.791V47.0121V47.0099Z",
    fill: "#FFB237"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6641 47.0099V49.3099H80.396V43.0421H86.6641V47.0121V47.0099Z",
    fill: "#FFB237"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.791 68.524V70.8241H47.5229V64.556H53.791V68.526V68.524Z",
    fill: "#FFB237"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6641 68.524V70.8241H80.396V64.556H86.6641V68.526V68.524Z",
    fill: "#FFB237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyBelt);
export default __webpack_public_path__ + "static/media/safety-belt.665777bd5277d0b705b4f06bb47136d3.svg";
export { ForwardRef as ReactComponent };